import React from "react";
import TaskResponseSummary from "./TaskResponseSummary";

export default function TaskCheckboxCompleted(props) {
  return <TaskResponseSummary {...props} />;
}
